export const educationData = [
  {
    id: 1,
    institution: "The Islamia University of Bahawalpur",
    course: "Bachelor of Science in Computer Science",
    startYear: "2019",
    endYear: "2023",
  },
  {
    id: 2,
    institution: "Punjab College Bahawalnagar",
    course: "F.Sc (Pre-Engineering)",
    startYear: "2016",
    endYear: "2018",
  },
  {
    id: 3,
    institution: "Model Secondary School Bahawalnagar",
    course: "Computer Science",
    startYear: "2013",
    endYear: "2015",
  },
];
